import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const getLangIdFromLocale = (locale) => {
  if (locale === 'id') return '2225';
  if (locale === 'cn') return '2226';
  return '2224';
};

const Interest = () => {
  const { t, i18n } = useTranslation();
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [interestOptions, setInterestOptions] = useState([]);
  const [selectedInterestUids, setSelectedInterestUids] = useState([]);
  const [englishInterestOptions, setEnglishInterestOptions] = useState([]);

  const ID = localStorage.getItem('userID');

  // Fetch English interests for submission (always fetch English version)
  useEffect(() => {
    const fetchEnglishInterests = async () => {
      try {
        const response = await fetch(
          `https://xianhefairy.com/Lotusfairy_api/api/SiteContent/GetListInterest?LangId=2224`
        );
        const data = await response.json();
        if (Array.isArray(data)) {
          setEnglishInterestOptions(data);
        }
      } catch (error) {
        console.error('Error fetching English interests:', error);
      }
    };
    fetchEnglishInterests();
  }, []);

  // Fetch interests based on language for display
  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const langId = getLangIdFromLocale(i18n.language);
        const response = await fetch(
          `https://xianhefairy.com/Lotusfairy_api/api/SiteContent/GetListInterest?LangId=${langId}`
        );
        const data = await response.json();
        if (Array.isArray(data)) {
          setInterestOptions(data);
        }
      } catch (error) {
        console.error('Error fetching interests:', error);
      }
    };
    fetchInterests();
  }, [i18n.language]); // Refetch when language changes

  const handleCheckboxChange = (uid, description) => {
    const isSelected = selectedInterestUids.includes(uid);
    
    if (isSelected) {
      // Remove from selection
      setSelectedInterestUids(prev => prev.filter(id => id !== uid));
      setSelectedTopics(prev => prev.filter(item => item !== description));
    } else {
      // Add to selection
      setSelectedInterestUids(prev => [...prev, uid]);
      setSelectedTopics(prev => [...prev, description]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!ID) {
      alert(t('interest.alerts.missingUserID'));
      return;
    }

    if (selectedTopics.length === 0) {
      alert(t('interest.alerts.selectAtLeastOne'));
      return;
    }

    setShowConfirmModal(true);
  };

  const confirmSubmission = async () => {
    const langId = getLangIdFromLocale(i18n.language);
    
    const result = await postCustomerInterest(
      ID,
      selectedInterestUids.join(","),
      langId
    );

    if (result.success) {
      setShowConfirmModal(false);
      setShowSuccessModal(true);
    } else {
      console.error("Error submitting interests:", result);
      alert(t('interest.alerts.submissionFailed'));
    }
  };

  const postCustomerInterest = async (
    customerId,
    interestUid,
    langId,
  ) => {
    // Build query parameters
    const params = new URLSearchParams({
      CustId: customerId,
      InterestUid: interestUid,
      LangId: langId,
    });

    const API_ENDPOINT = `https://xianhefairy.com/Lotusfairy_api/api/user/UpdateUserInterest?${params.toString()}`;

    console.log('📤 POST with query params:', API_ENDPOINT);

    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        // No body needed - using query parameters
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        console.error('API error:', {
          status: response.status,
          statusText: response.statusText,
          errorData: errorData,
        });
        return {
          success: false,
          status: response.status,
          statusText: response.statusText,
          errorData: errorData,
          message: `HTTP error! Status: ${response.status} ${response.statusText}`,
        };
      }

      const data = await response.json();
      console.log({
        success: true,
        data: data,
      });
      return {
        success: true,
        data: data,
      };
    } catch (error) {
      console.error('Error posting customer interest:', error);
      return {
        success: false,
        error: error.message || 'Unknown error occurred',
        message:
          'Failed to post customer interest. Please check your network connection.',
      };
    }
  };

  useEffect(() => {
    const userName = localStorage.getItem("username");
    const userID = localStorage.getItem("userID");
    const langId = localStorage.getItem("LangId") || "2224"; // Get from storage with fallback

    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              UserName: userName,
              ID: userID,
              LangId: parseInt(langId),
              UserToken: "",
              Token: {
                AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
              },
            }),
          }
        );

        const result = await response.json();
        console.log("API Response:", result);

        if (response.ok) {
          const profile = result?.Profiles?.[0];
          if (profile?.Interest && Array.isArray(profile.Interest)) {
            // Interest is now an array of objects with {Uid, Description}
            const uidsFromAPI = profile.Interest.map(item => item.Uid);
            setSelectedInterestUids(uidsFromAPI);
            
            // Match UIDs with current interest options to show descriptions
            const matchedTopics = interestOptions
              .filter(option => uidsFromAPI.includes(option.Uid))
              .map(option => option.Description);
            setSelectedTopics(matchedTopics);
          }
        } else {
          throw new Error(
            `Error: ${response.status} - ${result.message || "Request failed"}`
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (interestOptions.length > 0) {
      fetchData();
    }
  }, [interestOptions]);

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit}>
        <h2 style={styles.heading}>{t('interest.title')}</h2>
        <div style={styles.centerContainer}>
          <div style={styles.interestsContainer}>
            {interestOptions.map((option) => (
              <label key={option.Uid} style={styles.label}>
                <input
                  type="checkbox"
                  value={option.Uid}
                  checked={selectedInterestUids.includes(option.Uid)}
                  onChange={() => handleCheckboxChange(option.Uid, option.Description)}
                  style={styles.checkbox}
                />
                {option.Description}
              </label>
            ))}
          </div>
        </div>
        <div style={styles.submitContainer}>
          <button type="submit" style={styles.submitButton}>
            {t('interest.submit')}
          </button>
        </div>
      </form>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>{t('interest.confirmModal.title')}</h3>
            <p>{t('interest.confirmModal.message')}</p>
            <ul>
              {selectedTopics.map((topic, index) => (
                <li key={index}>{topic}</li>
              ))}
            </ul>
            <button onClick={confirmSubmission} style={styles.confirmButton}>
              {t('interest.confirmModal.confirm')}
            </button>
            <button onClick={() => setShowConfirmModal(false)} style={styles.closeButton}>
              {t('interest.confirmModal.cancel')}
            </button>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>{t('interest.successModal.title')}</h3>
            <p>{t('interest.successModal.message')}</p>
            <button onClick={() => window.location.reload()} style={styles.closeButton}>
              {t('interest.successModal.close')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    minHeight: "100vh",
    backgroundColor: "black",
    padding: "20px 16px",
    boxSizing: "border-box",
  },
  centerContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  interestsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '15px',
    color: "#DFBD69",
    width: "100%",
    maxWidth: "500px",
    justifyContent: "center",
  },
  heading: { textAlign: 'center', fontSize: '1.8rem', color: "#DFBD69", marginBottom: '20px' },
  label: { fontSize: '1rem', color: "#DFBD69", cursor: 'pointer', display: 'flex', alignItems: 'flex-start', lineHeight: 1.4 },
  checkbox: { marginRight: '10px', marginTop: '3px', transform: 'scale(1.2)', flexShrink: 0 },
  submitContainer: { display: 'flex', justifyContent: 'center', marginTop: '30px' },
  submitButton: { backgroundColor: '#DFBD69', color: 'black', padding: '10px 20px', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: '16px' },
  modalContent: { backgroundColor: '#151517', padding: '20px', borderRadius: '10px', textAlign: 'center', width: '100%', maxWidth: '350px', boxSizing: 'border-box', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', color: "#DFBD69" },
  confirmButton: { backgroundColor: '#DFBD69', color: '#151517', padding: '10px 20px', border: 'none', borderRadius: '8px', cursor: 'pointer', margin: '10px', minWidth: '100px' },
  closeButton: { backgroundColor: '#dc3545', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: '8px', cursor: 'pointer', margin: '10px', minWidth: '100px' },
};

export default Interest;